import axios from 'axios'
import { ResponseObjectUploadId } from '../../../models'
const BASEURLCENTRAL = process.env.REACT_APP_DEV_API_CENTRAL_URL
const BASEURL = process.env.REACT_APP_DEV_API_MICROSOFT_URL
const BASEURLHOTLERIA = process.env.REACT_APP_DEV_API_HOTELERIA_URL
export function getIsMicrosoft() {
  return axios.get<any>(`${BASEURLCENTRAL}/identity/ismicrosoftactive`)
}

export const redirectLoginMicrosoft = `${BASEURL}/authenticate/callmicrosoft`

export const logoutSaveToken = (body: any) => {
  return axios.post<any>(`${BASEURL}/authenticate/logoutSaveToken`, body)
}

export const logoutWithoutSaveToken = (body: any) => {
  return axios.post<any>(`${BASEURL}/authenticate/logoutSaveToken`, body, {
    headers: { Authorization: `Bearer ${body.token}` },
  })
}

export function getLoadIdWithout(token: string) {
  return axios.get<ResponseObjectUploadId>(`${BASEURLHOTLERIA}/bulkLoad/getBulkLoad_Id`, {
    headers: { Authorization: `Bearer ${token}` },
  })
}

export const logoutService = () => {
  return axios.post<any>(`${BASEURL}/authenticate/logout`)
}

export const redirectLogoutMicrosoft = `${BASEURL}/authenticate/logout`
